import { Injectable } from "@angular/core";
import { BehaviorSubject, debounceTime, distinctUntilChanged, Observable, skip } from "rxjs";
import { CacheService } from "./cache.service";

export interface I_Activity {
  timestamp: number;
}

export const LAST_ACTIVITY_TIME_KEY = "lastActivityTime";
@Injectable({
  providedIn: "root",
})
export class ActivityMonitorService {
  private _activity: BehaviorSubject<I_Activity> = new BehaviorSubject({ timestamp: Date.now() });
  private _focus: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(private _cacheService: CacheService) {
    this._activity = new BehaviorSubject(this._cacheService.getJson<I_Activity>(LAST_ACTIVITY_TIME_KEY) || { timestamp: Date.now() });

    this._activity
      .pipe(
        skip(1), // Ignore the initial value which will be the current time
        debounceTime(250) // Debounce to prevent multiple updates in a short period of time
      )
      .subscribe((activity) => {
        this._cacheService.setJson(LAST_ACTIVITY_TIME_KEY, activity);
      });
  }

  public get activity(): BehaviorSubject<I_Activity> {
    return this._activity;
  }

  public get lastActivity(): number {
    return this._activity.value.timestamp;
  }

  public get focus(): Observable<boolean> {
    return this._focus.pipe(distinctUntilChanged());
  }

  public track(): void {
    this._activity.next({
      timestamp: Date.now(),
    });
  }

  public onBlur(): void {
    this._focus.next(false);
  }

  public onFocus(): void {
    this._focus.next(true);
  }

  public clear(): void {
    const activity = {
      timestamp: Date.now(),
    };

    this._activity.next(activity);
    this._cacheService.delete(LAST_ACTIVITY_TIME_KEY);
  }
}
